export function removeLocationFromChannelName (name: string){
  return name.endsWith(')') ? name.slice(0, -4) : name;
}
